__turbopack_context__.v({
  "body": "styles-module-scss-module__3hpoMW__body",
  "staticBanner": "styles-module-scss-module__3hpoMW__staticBanner",
});
